import React from "react";
export var Data = function Data(_ref) {
  var jsonKey = _ref.jsonKey,
      json = _ref.json;
  if (!json) return /*#__PURE__*/React.createElement("pre", null, "\"".concat(jsonKey, "\": {}"));
  return /*#__PURE__*/React.createElement("pre", null, "\"".concat(jsonKey, "\": ").concat(JSON.stringify(json, null, 2)));
};